var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcludedOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM11.25 10.1925L10.1925 11.25L7.5 8.5575L4.8075 11.25L3.75 10.1925L6.4425 7.5L3.75 4.8075L4.8075 3.75L7.5 6.4425L10.1925 3.75L11.25 4.8075L8.5575 7.5L11.25 10.1925Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludedOptionIcon);
export default __webpack_public_path__ + "static/media/ExcludedOptionIcon.3aa892a67c8921550e43c7a11a80dbef.svg";
export { ForwardRef as ReactComponent };